import images from "../../assets/images/assets";
import Product from "./Product";

const ProductDetails = () => {
  return (
    <div className="bg-transparent w-full p-4 relative">
      <div className="bg-transparent ">
        <Product />
      </div>

      {/* Decorative Blur */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute -left-70 md:-left-80 lg:-left-200 top-0 saturate-150 mirror-x lg:top-5 "
      />
      <img
        src={images.blur_3}
        alt="blur"
        className="absolute -right-20 -bottom-5 md:bottom-10 saturate-200 lg:-right-70 "
      />
    </div>
  );
};

export default ProductDetails;
